import { EmitService } from './emit.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CountersService {
  intervaloEspera: any;

  constructor(
    private emit: EmitService
  ) { }

   //Contador de tiempo de espera para verificar si hay turnos
   inicioEspera(esperando: number): void {
    this.intervaloEspera = setInterval(() => {
      esperando--;
      if (esperando === 0) {
        this.finEspera();
        this.emit.enviarData('sesion');
      }
    }, 1000);
  }

  finEspera() {
    clearInterval(this.intervaloEspera);
  }
}
